<template>
  <div>
    <div class="relative z-10 container-bg flex flex-col text-center items-center p-4 md:p-10 2xl:p-20 space-y-8 m-8 lg:m-12 2xl:m-24">
      <img src="@/assets/images/check-circle.svg" style="width: 96px; height: 96px;">
      <h1 class="mb-11 text-45 text-semantic-base font-medium leading-10">Thank You for registering with us</h1>
      <p class="text-lg text-semantic-muted leading-6 mb-11">
        You will now receive a verification email in your inbox. Please verify by clicking "Complete Registration"
        on the email and we will then submit your account for approval
      </p>

      <router-link class="btn-success flex justify-center items-center" :to="{name: 'login'}">
        <svg width="22" height="22" class="mr-2" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- eslint-disable-next-line max-len -->
            <path d="M14.5245 11.7048H0.89817C0.509113 11.7048 0.193359 11.3891 0.193359 11C0.193359 10.6109 0.509113 10.2952 0.89817 10.2952H14.5245C14.9135 10.2952 15.2293 10.6109 15.2293 11C15.2293 11.3891 14.9135 11.7048 14.5245 11.7048Z" fill="#173630"/>
            <!-- eslint-disable-next-line max-len -->
            <path d="M10.7655 15.4637C10.585 15.4637 10.4047 15.3953 10.2674 15.2571C9.99205 14.9818 9.99205 14.5354 10.2674 14.2599L13.5283 10.9991L10.2674 7.73819C9.99205 7.46287 9.99205 7.01634 10.2674 6.74102C10.5429 6.46571 10.9892 6.46571 11.2645 6.74102L15.0235 10.5001C15.2988 10.7754 15.2988 11.2218 15.0235 11.4971L11.2645 15.2561C11.1264 15.3953 10.946 15.4637 10.7655 15.4637Z" fill="#173630"/>
            <!-- eslint-disable-next-line max-len -->
            <path d="M11.4703 21.3373C7.19346 21.3373 3.41766 18.7643 1.84922 14.7815C1.7064 14.4206 1.88484 14.0109 2.24671 13.8681C2.60754 13.7272 3.01828 13.9029 3.1611 14.2666C4.51532 17.7052 7.77713 19.9277 11.4703 19.9277C16.3926 19.9277 20.398 15.9223 20.398 11C20.398 6.07768 16.3926 2.07234 11.4703 2.07234C7.77713 2.07234 4.51532 4.29483 3.1611 7.73337C3.01725 8.09713 2.60754 8.27282 2.24671 8.13189C1.88484 7.98907 1.7064 7.57936 1.84922 7.21853C3.41766 3.23573 7.19346 0.66272 11.4703 0.66272C17.1699 0.66272 21.8076 5.30043 21.8076 11C21.8076 16.6996 17.1699 21.3373 11.4703 21.3373Z" fill="#173630"/>
        </svg>
        Back to login
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThankYou',
  mounted() {
    // NOTE: remove background img (pink substrate)
    document.querySelector('#app').classList.add('thank-you')
  }
};
</script>
